__turbopack_context__.v({
  "className": "montserrat_b62b8c09-module__G4HY0a__className",
});
